import style from './AddEditAppointment.module.scss'
import { useState } from 'react';
import Input from 'pages/Book/ClientBook/UI/Input/Input';
import OptionsSelection from 'pages/Book/ClientBook/UI/OptionsSelection/OptionsSelection';
import DateSelection from 'pages/Book/ClientBook/UI/DateSelection/DateSelection';
import api from 'helpers/api';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Loader from 'components/miscellaneous/Loader/Loader';
import { setAlert } from "store/alerts-slice";
import moment from 'moment';

const AddEditAppointment = ({ close, appointment, doDelete }) => {
    const mode = appointment ? 'edit' : 'add';
    const unspecifiedService = {
        id: null,
        label: 'Unspecified'
    };
    const dispatch = useDispatch();
    const [ isLoading, setIsLoading ] = useState(true);
    const [ clinic, setClinic ] = useState(null);
    const [ service, setService ] = useState(unspecifiedService)
    const [ serviceOptions, setServiceOptions ] = useState([])
    const [ date, setDate ] = useState(appointment ? appointment.scheduled_at : null)
    const [ firstName, setFirstName ] = useState(appointment ? appointment.customer_first_name : null);
    const [ lastName, setLastName ] = useState(appointment ? appointment.customer_last_name : null);
    const [ phone, setPhone ] = useState(appointment ? appointment.customer_phone : null);
    const [ email, setEmail ] = useState(appointment ? appointment.customer_email : null);
    const [ selectedStaff, setSelectedStaff ] = useState({
        id: null,
        label: 'Random Practitioner'
    });
    const [ notifyPatient, setNotifyPatient ] = useState(true);

    const clinicId = useSelector(state => state.auth?.clinic?.id)
    const getClinic = async () => {
        setIsLoading(true)
        try {
            const res = await api.get(`/booking/verify/clinic/${clinicId}`);
            if (res.success && res.data.success) {
                setClinic(res.data.data);
            }
        } catch (e) {
            setClinic(false)
        } finally {
            //setIsLoading(false)
        }
    }

    useEffect(() => {
        if (clinicId) {
            getClinic()
        }
    }, [ clinicId ])

    useEffect(() => {
        if (clinic !== null) {
            setIsLoading(false)
            if (mode == 'edit') {
                setService(getServiceList().find(s => s.id == appointment.service_id));
                if (Object.keys(appointment.service_options).length > 0) {
                    setServiceOptions(parseExistingServiceOptions(appointment.service_options))
                }
                setSelectedStaff(getStaffOptions().find(staff => staff.id == appointment.staff_id))
            }
        }
    }, [ clinic ])


    const canSubmit = () => {
        return !!firstName && !!lastName && !!phone && !!email && date !== null;
    }

    const getServiceList = () => {
        return [
            unspecifiedService,
            ...clinic.services.map((s) => {
                return {
                    id: s.id,
                    label: s.name,
                    icon: s.icon,
                    options: s.options
                }
            })
        ]
    }

    const getStaffOptions = () => {
        return [
            { id: null, label: 'Random Staff' },
            ...clinic.staff.map((s) => {
                return {
                    id: s.id,
                    label: s.name
                }
            })
        ]
    }

    const parseExistingServiceOptions = (options) => {
        const parsed = {}
        Object.keys(options).forEach(key => {
            parsed[ key ] = options[ key ].map((o) => {
                return {
                    id: o,
                    label: o.charAt(0).toUpperCase() + o.slice(1)
                }
            })
        })

        return parsed
    }

    const getServiceOptionsByKey = () => {
        const options = Object.keys(serviceOptions).length > 0 ? Object.keys(serviceOptions).map((o) => {
            return {
                'key': o,
                'value': serviceOptions[ o ].map((o) => {
                    return o.id
                })
            }
        }) : [];

        const optionsByKey = {};

        if (options.length > 0) {
            options.forEach((o) => {
                optionsByKey[ o.key ] = o.value;
            })
        }

        return optionsByKey;
    }

    const submit = async () => {
        setIsLoading(true);
        try {
            const payload = {
                clinic_id: clinic.id,
                service_id: service && service.id ? service.id : null,
                service_options: getServiceOptionsByKey(),
                staff_id: selectedStaff.id,
                customer_first_name: firstName,
                customer_last_name: lastName,
                customer_phone: phone,
                customer_email: email,
                tos: true,
                agree_to_sms: notifyPatient,
                scheduled_at: date.format('YYYY-MM-DD HH:mm:ss')
            }

            const res = mode == 'add' ? await api.post('/booking', payload) : await api.patch(`/booking/${appointment.token}`, {
                ...appointment,
                ...payload,
                notify: isDateChanged() ? notifyPatient : false
            });

            if (res.success && res.data.success) {
                dispatch(setAlert({ type: 'success' }))
                close()
            } else {
                dispatch(setAlert({ type: 'error' }))
            }


        } catch (e) {
            dispatch(setAlert({ type: 'error' }))
        } finally {
            setIsLoading(false)
        }
    }

    const checkAvailableTimes = async (dateRange) => {
        try {
            const res = await api.get(`/booking/verify/dates/${clinic.id}`, {
                'start_date': dateRange.start,
                'end_date': dateRange.end,
                'staff_id': selectedStaff.id,
                'booking_id': appointment ? appointment.id : null
            })

            if (res.success && res.data.success) {
                return res.data.data;
            }
        } catch (e) {

        } finally {
        }

        return null;
    }

    const isDateChanged = () => {
        return mode === 'edit' && date && typeof date === 'object' && appointment.scheduled_at !== date.format('YYYY-MM-DD HH:mm:ss')
    }

    return (
        <>
            <div>
                <h3 style={ { margin: 0 } }>
                    { mode === 'add' ? 'Add Appointment' : 'Edit Appointment' }
                </h3>
            </div>
            <div className={ style.content }>
                { !isLoading ? <>
                    <>
                        <section style={ { marginTop: 15 } }>
                            <OptionsSelection selected={ service } options={ getServiceList() } label={ 'Choose Service' } setSelected={ setService } />
                            { (service.id !== undefined && service?.options !== null && service?.options !== undefined) && <div className={ style.optionGroup }>
                                { service.options.map((o, i) => {
                                    return (<div key={ i } className={ style.optionGroup }>
                                        <OptionsSelection label={ o.title } selected={ serviceOptions[ o.id ] } options={ o.options } setSelected={ (selection) => {
                                            setServiceOptions({ ...serviceOptions, [ o.id ]: selection })
                                        } } multi={ o.multi } placeholder={ o.placeholder } />
                                    </div>)
                                }) }
                            </div> }
                            <OptionsSelection selected={ selectedStaff } options={ getStaffOptions() } label={ 'Choose Staff' } setSelected={ setSelectedStaff } />
                        </section>
                        <h4>Customer Details</h4>
                        <div className={ style.inputRow }>
                            <Input required={ true } type="text" label="First Name" value={ firstName } onValueChange={ setFirstName } />
                            <Input required={ true } type="text" label="Last Name" value={ lastName } onValueChange={ setLastName } />
                        </div>
                        <div className={ style.formGroup }>
                            <Input required={ true } type="phone" label="Phone" value={ phone } onValueChange={ setPhone } />
                        </div>
                        <div className={ style.formGroup }>
                            <Input required={ true } type="email" label="Email" value={ email } onValueChange={ setEmail } />
                        </div>
                        <DateSelection dailyWorkingHoursRange={ clinic.working_hours } label={ "Choose date & time" } dateValue={ date } useDefaultTime={ mode === 'edit' && true } checkAvailableTimes={ checkAvailableTimes } staffId={selectedStaff.id} onChange={ setDate } maxHeight={ 200 } />
                        { mode === 'add' || isDateChanged() && <div className={ style.formGroup } style={{
                            marginTop: 15
                        }}>
                            <Input type="checkbox" value={ notifyPatient } onValueChange={ setNotifyPatient } label={ mode === 'add' ? "Notify patient about the appointment" : "Notify patient about date change" } />
                        </div> }
                        <div style={ { minHeight: 100 } }></div>
                    </>

                    <div className={ style.footer }>
                        { mode == 'edit' && <button className='alma-button' style={ {
                            background: '#ff5e35',
                        } } onClick={ (e) => {
                            doDelete(appointment)
                        } }>Delete</button> }
                        <button onClick={ (e) => {
                            submit()
                        } } disabled={ !canSubmit() } className='alma-button'>
                            { mode === 'add' ? 'Create Appointment' : 'Save Changes' }
                        </button>
                    </div>
                </> : <>
                    <div className={ style.loader }>
                        <Loader color="#ddd" />
                    </div>
                </> }
            </div>

        </>
    );
}

export default AddEditAppointment;